const firebaseConfig = {
    apiKey: "AIzaSyBRddLx_3P82kXnei4IOGGcw-bCH1DJDho",
    authDomain: "electronica-214014.firebaseapp.com",
    databaseURL: "https://electronica-214014.firebaseio.com",
    projectId: "electronica-214014",
    storageBucket: "electronica-214014.appspot.com",
    messagingSenderId: "250505857055",
    appId: "1:250505857055:web:cec05f8e777173e6846d2a"
};

const vapidKey = "BCILmGvlDeT1HTWKgRng1OxOZPCvgl2Jr2oBWBrPhaYQidMMCMhjR_wo1JPuf6dWMFS7L4PafYIiBxD59WB79e0";

export {
    firebaseConfig,
    vapidKey
}